import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import ChangeEmailService from "./ChangegEmailService.jsx";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import FormControl from "react-bootstrap/FormControl";

import Result from "../../../components/result/Result.jsx";
import Spinner from "react-bootstrap/Spinner";
import { utils } from "../../../utils/Utils.jsx";
import ErrorMessageComponent from "../../../components/errorMessageComponent/ErrorMessageComponent.jsx";

const ChangeEmail = (props) => {
  const [isMobileWidth, setIsMobileWidth] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const [stage, setStage] = useState(1);
  const [invalidNewEmail, setInvalidNewEmail] = useState(false);
  const [loadingSent, setLoadingSent] = useState(false);
  const [errorMessageType, setErrorMessageType] = useState("");

  const service = new ChangeEmailService();
  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  useEffect(() => {
    if (
      props.location &&
      props.location.megastate &&
      props.location.megastate.email
    ) {
    } else {
      utils.goToURL(props, "/dashboard/settings");
    }

    const setState = (updates) => {
      if (updates.isMobileWidth !== undefined)
        setIsMobileWidth(updates.isMobileWidth);
    };

    utils.checkWindowWidth(
      setState,
      props.changeGoBackNavBar,
      true,
      "/dashboard/settings",
    );

    const handleResize = () => {
      utils.checkWindowWidth(
        setState,
        props.changeGoBackNavBar,
        true,
        "/dashboard/settings",
      );
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const changeEmail = () => {
    setErrorMessageType("");

    if (newEmail != "") {
      if (emailRegex.test(newEmail)) {
        setInvalidNewEmail(false);
        setErrorMessageType("");
        setLoadingSent(true);

        const state = { newEmail };
        const setState = (updates) => {
          if (updates.loadingSent !== undefined)
            setLoadingSent(updates.loadingSent);
          if (updates.stage !== undefined) setStage(updates.stage);
          if (updates.invalidNewEmail !== undefined)
            setInvalidNewEmail(updates.invalidNewEmail);
        };

        service.changeEmail(
          props.token,
          state,
          setState,
          setMessages,
          props.getClientConfig,
        );
      } else {
        setMessages("please-enter-a-valid-email");
        setInvalidNewEmail(!emailRegex.test(newEmail));
      }
    } else {
      setMessages("one-or-more-required-fields-are-missing");
      setInvalidNewEmail(newEmail === "");
    }
  };

  const setMessages = (type) => {
    setErrorMessageType(type);
  };

  const handleChange = (e) => {
    setNewEmail(e.target.value);
  };

  return (
    <React.Fragment>
      <div class="verify-info-container page-container">
        <div class="middle-container container-padding">
          {stage === 1 ? (
            <div class="form-container">
              <div class="main-title">
                {props.localizedText["change-email"]}
              </div>
              <div class="fade-in-up">
                <div class="message">
                  {
                    props.localizedText[
                      "you-will-need-yo-verify-your-email-address-after-making-any-changes-to-it"
                    ]
                  }
                </div>
                <div class="div-parent-flex-column">
                  <Form.Group className="mb-3">
                    <Form.Label className="input-label-outside-div">
                      {props.localizedText["email-address"]}
                    </Form.Label>
                    <FormControl
                      type="text"
                      name="email"
                      value={
                        props.location &&
                        props.location.megastate &&
                        props.location.megastate.email
                          ? props.location.megastate.email
                          : ""
                      }
                      disabled
                      className="input-field"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label className="input-label-outside-div">
                      {props.localizedText["new-email"]}
                    </Form.Label>
                    <FormControl
                      name="newEmail"
                      value={newEmail}
                      onChange={handleChange}
                      isInvalid={invalidNewEmail}
                      className="input-field"
                      disabled={loadingSent}
                    />
                  </Form.Group>
                  <ErrorMessageComponent
                    errorMessage={props.localizedText[errorMessageType]}
                  ></ErrorMessageComponent>
                  <div class="buttons-div">
                    <Button
                      className="primary-button outside-primary-button"
                      onClick={changeEmail}
                      disabled={loadingSent}
                    >
                      {loadingSent ? (
                        <Spinner className="loader-send-outside-div-button"></Spinner>
                      ) : null}
                      {props.localizedText["change"]}
                    </Button>

                    <Button
                      className="secondary-button outside-secondary-button"
                      onClick={() =>
                        utils.goToURL(props, "/dashboard/settings")
                      }
                    >
                      {props.localizedText["cancel"]}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Result
              success={true}
              secondButton={true}
              title={props.localizedText["success"]}
              message={
                props.localizedText[
                  "your-email-address-has-been-successfully-changed"
                ]
              }
              primaryButtonText={props.localizedText["verify-email"]}
              primaryButtonFunction={() =>
                utils.goToURL(props, "/dashboard/settings/verify-email")
              }
              secondaryButtonText={props.localizedText["settings"]}
              secondaryButtonFunction={() =>
                utils.goToURL(props, "/dashboard/settings")
              }
            ></Result>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ChangeEmail);
